import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postbedTypes } from "../store/slices/bedtype";
import { Loader } from "semantic-ui-react";
import Footer from "./footer";
import { API_PATHS } from "../utils/constants/api.constants";
import Navbarside from "../component/Navbarside";

function UploadBedType(e) {
  const [name, setName] = useState("");
  const [imageUrl, setimageUrl] = useState("");

  const [alertname, setAlertname] = useState("");
  const [alertimageUrl, setAlertimageUrl] = useState("");

  const navigate = useNavigate("");
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  async function imageUpload(e) {
    e.preventDefault();
    var formdata = new FormData();
    formdata.append("file", e.target.files[0]);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let response = await fetch(API_PATHS.uploadImage, requestOptions);
    let data = await response.json();
    setimageUrl(data.data.location);
  }

  async function upload(e) {
    e.preventDefault();
    let item = { name, imageUrl };

    dispatch(postbedTypes(item))
      .unwrap()
      .then(() => {
        alert("Uploaded successfully");
        navigate("/BedType");
      })
      .catch(({ message }) => {
        alert(message);
      });
  }

  const save = (e) => {
    const regtext = /^(([A-Za-z]+[,.]?[ ]?|[a-z]+['-]?|[0-9])+)$/;
    if (regtext.test(name)) {
      setAlertname("");
    } else if (!regtext.test(name) && name === "") {
      setAlertname("Please enter bed type");
      e.preventDefault();
    } else {
      setAlertname("");
    }

    const regimage = /(gif|jpe?g|tiff?|png|webp|bmp)$/i;
    if (regimage.test(imageUrl)) {
      setAlertimageUrl("");
    } else if (!regimage.test(imageUrl) && imageUrl === "") {
      setAlertimageUrl("Please enter image link");
      e.preventDefault();
    } else {
      setAlertimageUrl("Invalid file");
      e.preventDefault();
    }
  };

  const clear = () => {
    navigate(-1);
  };

  return (
    <body data-col="2-columns" className=" 2-columns ">
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row match-height">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-warning">
                        <h4
                          className="card-title"
                          id="basic-layout-form-center"
                        >
                          Upload Bed Type
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="px-3">
                        <form className="form" onSubmit={upload}>
                          <div className="row justify-content-md-center">
                            <div className="col-md-6">
                              <div className="form-body">
                                <div className="form-group">
                                  <label for="placeTextarea">Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    Placeholder="Bed Type Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    // required
                                  />
                                  <p className="alert-message">{alertname}</p>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-body">
                                <div className="form-group">
                                  <label for="placeTextarea">Image</label>
                                  <input
                                    type="file"
                                    className="form-control-file"
                                    Placeholder="Price Tagline"
                                    name="imageUrl"
                                    onChange={(e) => imageUpload(e)}
                                    // required
                                  />

                                  <p className="alert-message">
                                    {alertimageUrl}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <div className="form-actions center">
                                <button
                                  type="submit"
                                  className="btn btn-blue"
                                  onClick={save}
                                  disabled={!imageUrl}
                                >
                                  <i className="icon-note"></i> Save
                                </button>
                                &nbsp;
                                <button
                                  type="reset"
                                  onClick={clear}
                                  className="btn btn-warning mr-1"
                                >
                                  <i className="icon-trash"></i> Cancel
                                </button>
                              </div>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}
export default UploadBedType;
